import { request, simpleRequest } from '../request';
import qs from 'qs'

/** get application list with pagination */
export function fetchApplication(params?: Api.Application.ApplicationSearchParams) {
  return request<Api.Application.ApplicationList>({
    url: '/application/list',
    method: 'get',
    params
  });
}

export function fetchAppStoreInfo(params: Api.Application.AppStoreInfoParams) {
  return request<Api.Application.AppStoreInfo>({
    url: '/statistic/listAppStoreInfo',
    method: 'get',
    params
  });
}

export function updateApplicationDetail(params: Api.Application.UpdateApplicationDetailParams) {
  return request<boolean>({
    url: '/application/updateApplicationDetail',
    method: 'post',
    params
  });
}

export function fetchReviewReply(params: { reviewIds: string[] }) {
  return request<Api.Application.ReviewReplyGenerateItem[]>({
    url: '/review/reviewReply',
    method: 'post',
    params,
    paramsSerializer: function (p: any) {
      return qs.stringify(p, { arrayFormat: 'repeat' })
    },
  });
}

export function fetchReviewsByReviewIds(reviewIds: string[]) {
  return request<Api.Application.Review[]>({
    url: '/review/getByReviewIds',
    method: 'post',
    data: reviewIds
  });
}

export function sendReviewReplies(data: Api.Application.ReviewReplySendItem[]) {
  const payload = data.map(({ reviewId, replyContext }) => ({ reviewId, replyContext }));

  return request<Api.Application.ReviewReplySendResult[]>({
    url: '/review/sendReplies',
    method: 'post',
    data: payload
  });
}

export function clearPreparedReplies(reviewIds: string[]) {
  return request<number>({
    url: '/review/clearPreparedReplies',
    method: 'post',
    data: reviewIds
  });
}

export function fetchStoreReviews(params: Api.Application.ReviewSearchParams) {
  return request<Api.Application.ReviewList>({
    url: '/review/list',
    method: 'get',
    params,
    paramsSerializer: function (p: any) {
      return qs.stringify(p, { arrayFormat: 'repeat' })
    }
  });
}

export function fetchReviewDevelopers() {
  return request<string[]>({
    url: '/overview/getDevelopers',
    method: 'get'
  });
}

export function fetchReviewAppVersions(appids?: string[]) {
  return request<Api.Application.AppVersionInfo[]>({
    url: '/overview/listStoreAppVersions',
    method: 'get',
    params: appids ? { appids } : undefined,
    paramsSerializer: function (p: any) {
      return qs.stringify(p, { arrayFormat: 'repeat' })
    },
  });
}

/** get application list */
export function fetchMetricsTrend(value:any) {

  return simpleRequest<Api.Application.MetricsTrend[]>({
    url: '/statistic/listMetricsTrend',
    method: 'get',
    params: { rate: value },
  });
}

export function fetchMetricsTrendv2(params?: Api.Application.ApplicationSearchParams) {
  return request<Api.Application.MetricsTrend>({
    url: '/application/list',
    method: 'get',
    params
  });
}

/** get application list */
export function fetchMetricsTrendQueryOption() {

  return simpleRequest<any[]>({
    url: '/statistic/listMetricsTrendQueryOption',
    method: 'get'
  });
}

/** get application list */
export function fetchAppVersions(ids: string[]) {
  return simpleRequest<string[]>({
    url: '/overview/listAppVersions',
    method: 'get',
    params: { ids: ids },
    paramsSerializer: function (params: any) {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    },
  });
}

export function fetchAppListAppVersions(ids: string[]) {
  return simpleRequest<string[]>({
    url: '/application/listAppListAppVersions',
    method: 'get',
    params: { ids: ids },
    paramsSerializer: function (params: any) {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    },
  });
}

export function fetchABTestApplication() {
  return simpleRequest<Api.Application.Application[]>({
    url: '/overview/listAuthorizedApps',
    method: 'get',
    params: { type: 'abtest_app' }
  });
}

export function fetchCustomEventApplication() {
  return simpleRequest<Api.Application.Application[]>({
    url: '/overview/listAuthorizedApps',
    method: 'get',
    params: { type: 'custom_event' }
  });
}

/** get application list v2*/
export function fetchGetApplication() {
  return request<Api.Application.App[]>({
    url: '/application/listApplications',
    method: 'get'
  });
}

/** update application */

export function configAppRevenueSource(params: Api.Application.ConfigAppRevenueSourceParams) {
  return request<boolean>({
    url: '/application/configAppRevenueSource',
    method: 'post',
    params
  });
}
export function updateApplication(data?: Api.Application.Model) {
  const { id, appName, packageName, storeName, storeId } =  data || {};
  return request({
    url: '/application/update',
    method: 'post',
    data: {id, appName, packageName, storeName, storeId }
  });
}

export function exportRawFile(params: {
  appid: string;
  start: number;
  end: number;
}) {
  return request({
    url: '/customEvent/exportRawFile',
    method: 'get',
    params,
    responseType: 'blob', // 重要：设置响应类型为 blob
  });
}
